import React from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Icon from '@mdi/react';
import {mdiDownloadOutline} from '@mdi/js';
import {InventoryState} from '../reducer/InventoryReducer';
import InventoryDevice from '../interfaces/InventoryDevice';

const StyledButton = styled(Button)`
  grid-area: 'download';
  background-color: ${props => props.theme.activeStateBlue};
  text-transform: capitalize;
  font-family: 'Text Regular';
  border-radius: 10px;
  padding: 8px 12px;
  line-height: 18px;
  color: ${props => props.theme.defaultNavy};
  font-size: 0.75rem;
  &:hover {
    background-color: ${props => props.theme.activeStateBlue}77;
  }
  &.MuiButton-root.Mui-disabled {
    background-color: ${props => props.theme.grey}80;
    color: ${props => props.theme.defaultNavy};
  }
`;

function downloadCSV(tableDeviceData: InventoryDevice[]) {
  let csvContent = '';
  const header = [
    'Site CODE',
    'Name',
    'Brand',
    'GEO',
    'Site Type',
    'Site Status',
    'Store Concept',
    'Device Type',
    'Device Name',
    'Model',
    'Manufacturer',
    'Serial Number',
  ];
  csvContent += header.join(',') + '\r\n';

  tableDeviceData.forEach(device => {
    const {
      siteCode,
      siteName,
      brand,
      geo,
      siteType,
      siteStatus,
      storeConcept,
      deviceType,
      deviceName,
      model,
      manufacturer,
      serialNumber,
    } = device;

    const row = [
      siteCode,
      siteName,
      brand,
      geo,
      siteType,
      siteStatus,
      storeConcept,
      deviceType,
      deviceName,
      `"=""${model}"""`,
      manufacturer,
      serialNumber,
    ];

    csvContent += row.join(',') + '\r\n';
  });
  const blob = new Blob([csvContent], {type: 'text/csv;charset=utf-8;'});
  const blobUrl = URL.createObjectURL(blob);

  const date = new Date().toLocaleString();
  const link = document.createElement('a');
  link.href = blobUrl;
  link.download = `DeviceInventory-${date}.csv`;
  link.click();
  link.remove();
}

interface DownloadCSVProps {
  invState: InventoryState;
}

function DownloadCSV({invState}: DownloadCSVProps) {
  const {tableDeviceData, isDeviceDataReady} = invState;

  return (
    <StyledButton
      startIcon={<Icon path={mdiDownloadOutline} size={1} />}
      onClick={() => downloadCSV(tableDeviceData)}
      disabled={!isDeviceDataReady}
    >
      Download
    </StyledButton>
  );
}

export default DownloadCSV;
